import { Link } from 'react-router-dom';
import { dailyArticles } from '@/mocks/data';

export default function DailyPicks() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-3">
            🔥 每日精选
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight tracking-tight">
            今日热门爆料
          </h2>
          <p className="mt-3 text-sm text-foreground-500">精选全网最火爆的独家内容，每日更新不断</p>
        </div>

        <div className="overflow-x-auto pb-4 -mx-4 px-4 md:mx-0 md:px-0">
          <div className="flex gap-5 md:gap-6 min-w-max md:min-w-0 md:grid md:grid-cols-4">
            {dailyArticles.slice(0, 4).map((article, idx) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group block w-[280px] md:w-auto rounded-2xl bg-background-50 overflow-hidden transition-all duration-300 hover:bg-background-50 cursor-pointer flex-shrink-0"
              >
                <div className="aspect-[4/5] relative overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                  {idx === 0 && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-bold rounded-full">
                      今日最热
                    </span>
                  )}
                  <div className="absolute bottom-3 right-3 flex items-center gap-1 px-2 py-1 bg-black/50 backdrop-blur-sm rounded-full">
                    <i className="ri-eye-line text-white text-xs"></i>
                    <span className="text-white text-xs">
                      {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 bg-primary-50 text-primary-600 text-xs font-medium rounded-full">
                      {article.categoryName}
                    </span>
                    <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500"></i>
                      {article.hot}°热度
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-1-line"></i>
                      {Math.floor(article.views / 100)}评
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/meiri-dasai"
            className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-200 text-foreground-700 text-sm font-medium rounded-full hover:border-foreground-950 hover:text-foreground-950 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}